import React from 'react';
import ReactDOM from 'react-dom/client';
import MoskeDashboard from './MoskeDashboard';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<MoskeDashboard />);